export default {
  pledgeConfig: { method: 'get', url: '/api/v1/pledge/pledgeConfig', config: { requiresToken: true } }, // 获取质押配置
  pledgeGetOrder: { method: 'post', url: '/api/v1/pledge/order', config: { requiresToken: true } }, // 生成 XZEC 链上质押订单
  pledgeList: { method: 'get', url: '/api/v1/pledge/orders', config: { requiresToken: true } }, // 质押记录
  pledgeRedeem: { method: 'post', url: '/api/v1/pledge/redeem', config: { requiresToken: true } } // 到期后一次性赎回 XZEC 本金
}
